import React from 'react';
import './CpaRadioGroup.scss';
import proptypes from 'prop-types';
const { arrayOf, PropTypes } = proptypes;
import { Radio } from '@thd-olt-component-react/checkbox';
import { Col, Row } from '@thd-olt-component-react/grid';
import { getMyInformationOptionVal } from '../../constants/constants';

const handleRequestTypeInput = (name, value, callback) => {
  if (name === 'requestType') {
    if (value !== getMyInformationOptionVal) {
      callback('Email', 'deliveryMethod', true);
    } else {
      callback('', 'deliveryMethod', false);
    }
  }
};

function generateRadioGroup(options, callback, name, validation, spacing) {

  return options.map((option) => {
    return (
      <Col sm={spacing} key={option.name}>
        <Radio
          key={option.name}
          value={option.value}
          onChange={(event) => {
            callback(event.target.value, name, validation(event.target.value));
            handleRequestTypeInput(name, event.target.value, callback);
          }}
          id={option.name}
          formName={name}
        >
          {option.name}
        </Radio>
      </Col>
    );
  });
}

function generateRadioGroupForLexisNexisChoices(options, callback, questionId) {

  return options.map((option) => {
    return (
      <Row className="cpa-radio-choice-ln" key={option.name}>
        <Radio
          key={option.name}
          value={option.value.toString()}
          onChange={(event) => {
            callback(event.target.value, questionId);
          }}
          id={option.name}
          formName={questionId.toString()}
        >
          {option.name}
        </Radio>
      </Row>

    );
  });
}

const CpaRadioGroup = (props) => {
  const {
    header, options, callback, name, validation, spacing, questionId
  } = props;
  let generatedRadioGroup = (name === 'lexisNexisChoices')
    ? generateRadioGroupForLexisNexisChoices(options, callback, questionId)
    : generateRadioGroup(options, callback, name, validation, spacing);

  const classes = (name === 'lexisNexisChoices') ? 'cpa-radio-group-ln' : '';

  const formattedHeader = (name !== 'lexisNexisChoices') ? (
    <span>{header}<span style={{ color: 'red' }}>*</span></span>) : header;
  return (
    <Row>
      <Row>
        <Col xs="12" className={classes}>
          <label className="cpa-radio-group-label" htmlFor={header}>{formattedHeader}</label>
        </Col>
      </Row>
      <Row aria-labelledby={header}>
        {generatedRadioGroup}
      </Row>
    </Row>
  );
};

CpaRadioGroup.defaultProps = {
  questionId: -1,
  spacing: '2',
  validation: () => {
    return true;
  }
};

CpaRadioGroup.propTypes = {
  callback: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: arrayOf(PropTypes.object).isRequired,
  name: PropTypes.string.isRequired,
  validation: PropTypes.func,
  spacing: PropTypes.string,
  questionId: PropTypes.number,
};

CpaRadioGroup.displayName = 'CpaRadioGroup';
export { CpaRadioGroup };
